import React, { useState, useEffect, useCallback } from "react";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import "./TabMenu.scss";
import Tab from "./Tab";
export type tabView = "mfg-vertical" | "mfg-horizontal";


export interface Props {
  TabLabel: any[];
  TabValue: any[];
  tabView?: tabView;
  customClass?: string;
  customId?: string;
}
const TabMenu = ({ TabLabel, TabValue, tabView = "mfg-horizontal", customClass, customId }: Props) => {
  const [activeTab, setActiveTab] = useState(1);
  const [mobView, setMobView] = useState(false);
  const handleTabClick = (index: number) => {
    setActiveTab(index + 1);
  };

  const handleKeyDown = useCallback(
    (e: any) => {
      if (e.keyCode === 39) {
        // Right arrow
        e.preventDefault();
        setActiveTab(activeTab === TabLabel.length ? 0 : activeTab + 1);
      } else if (e.keyCode === 37) {
        // Left arrow
        e.preventDefault();
        setActiveTab(activeTab === 0 ? TabLabel.length : activeTab - 1);
      }
    },
    [TabLabel.length, activeTab]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown, false);
    return () => {
      document.removeEventListener("keydown", handleKeyDown, false);
    };
  }, [handleKeyDown]);

  return (
    <>
      <div className={`mfg-tabs-container ${tabView}${customClass ? ( ' ' + customClass) : ''}`} id={customId} role="tabpanel">
        <div className="tabs" role="tablist">
          <button className="tabMobile" onClick={() => setMobView(!mobView)}>
            Filter Tabs {!mobView ? <FaAngleDown /> : <FaAngleUp />}
          </button>
          <ul className={mobView ? "expand" : "collaps"}>
            {TabLabel.map((tab: any, index: number) => (
              <li key={index} data-target={activeTab === index + 1 ? 1 : 2}>
                <Tab
                  key={index}
                  label={TabLabel[index]}
                  onClick={() => {
                    handleTabClick(index);
                    setMobView(!mobView);
                  }}
                  isActive={index + 1 === activeTab}
                />
              </li>
            ))}
          </ul>
        </div>
        <div className="tab-content" data-target={activeTab}>
          {activeTab &&
            TabValue.map(
              (tab: any, index: number) =>
                activeTab === index + 1 && (
                  <div
                    key={index}
                    className={`content${
                      activeTab === index + 1 ? " " + "active" : ""
                    }`}
                    id={`panel-${TabLabel[index]}`}
                  >
                    {TabValue[index]}
                  </div>
                )
            )}
        </div>
      </div>
    </>
  );
};

export default TabMenu;
